import React, { useState, useEffect } from "react";
import { PageLayout } from "../../components/page-layout";
import { OnboardingProgressBar } from "../../components/onboarding-progress-bar";
import { useOnboarding } from "../../providers/onboarding-provider";
import { useAuth0 } from "@auth0/auth0-react";
import { getOnboardingStatus } from "../../services/backend.service";
import { FormShell } from "../../components/onyx/FormShell";
import { FormActions } from "../../components/onyx/Field";
import { Button } from "../../components/onyx/Button";
export const PendingApprovalPage = () => {
  const { fetchOnboardingStatus, navigateToLatestStep } = useOnboarding();
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(true);
  const [approvalData, setApprovalData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchApprovalStatus();
    
    // Poll for approval status every 30 seconds
    const interval = setInterval(fetchApprovalStatus, 30000);
    
    return () => clearInterval(interval);
  }, []);

  const fetchApprovalStatus = async () => {
    try {
      setLoading(true);
      const token = await getAccessTokenSilently();
      const { data, error } = await getOnboardingStatus(token);

      if (error) {
        setError(error);
        return;
      }

      if (data) {
        setApprovalData(data);
        
        // If user has been approved, refresh onboarding status and navigate to next step
        if (data.current_step !== 'PENDING_APPROVAL') {
          const refreshed = await fetchOnboardingStatus({ silent: true });
          navigateToLatestStep(refreshed || data);
        }
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading && !approvalData) {
    return (
      <PageLayout>
        <div className="content-layout">
          <OnboardingProgressBar />
          <FormShell>
            <h1 className="content__title">Loading...</h1>
          </FormShell>
        </div>
      </PageLayout>
    );
  }

  if (error) {
    return (
      <PageLayout>
        <div className="content-layout">
          <OnboardingProgressBar />
          <FormShell>
            <h1 className="content__title">Error</h1>
            <p className="content__body">
              {error.message || "An error occurred while checking your approval status."}
            </p>
            <FormActions>
              <Button type="button" variant="primary" onClick={fetchApprovalStatus}>
                Try Again
              </Button>
            </FormActions>
          </FormShell>
        </div>
      </PageLayout>
    );
  }

  const pendingApprovalStep = approvalData?.steps?.PENDING_APPROVAL;
  const pendingSince = pendingApprovalStep?.pending_since;

  return (
    <PageLayout>
      <div className="content-layout">
        <OnboardingProgressBar />
        <FormShell>
          <h2 className="content__title">Thank you for completing this pre-screen questionnaire!</h2>
          
          <p className="content__body">
            If you appear eligible based on your responses, we will contact you within 2 weeks with:
          </p>
          
          <ul className="onyx-stack-list">
            <li>Detailed information about the study</li>
            <li>Complete informed consent documents</li>
            <li>Opportunity to ask questions</li>
            <li>No obligation to participate</li>
          </ul>
          
          <p className="content__body">
            If you have immediate questions about this research, you can contact us at{' '}
            <a href="mailto:support@onyx.bio" className="contact-link">support@onyx.bio</a>.
          </p>
          
          <p className="content__body">
            Completing this survey does not enroll you in the study. If you're interested after reviewing the full study information, you'll have the opportunity to provide informed consent at that time.
          </p>
        </FormShell>
        
      </div>


    </PageLayout>
  );
}; 